export * from './app-header.component';



// WEBPACK FOOTER //
// ./src/app/components/app-header/index.ts